import { Team } from '@internal/schemas-common';
import { useMemo } from 'react';

import { orange, red } from '@material-ui/core/colors';
import {
  ScoreIndex,
  ScoreWithFixAndNoFix,
  StackedBarChart,
} from '@internal/ui-common';

export const VulnerabilityStackedBarChart = ({
  scores: _scores,
  teams: _teams,
}: {
  scores: ScoreIndex<ScoreWithFixAndNoFix>[];
  teams: Team[];
}) => {
  const chartData = useMemo(
    () =>
      _scores.map(sc => ({
        teamName: _teams[sc.index].name,
        team: _teams[sc.index],
      })),
    [_scores, _teams],
  );

  const series = useMemo(
    () => [
      {
        data: _scores.map(sc => sc.score.red.fix),
        label: 'Critical - Fixable',
        stack: 'fixable',
        barLabel: 'value' as const,
      },
      {
        data: _scores.map(sc => sc.score.orange.fix),
        label: 'High - Fixable',
        stack: 'fixable',
        barLabel: 'value' as const,
      },
      {
        data: _scores.map(sc => sc.score.red.noFix),
        label: 'Critical - Not Fixable',
        stack: 'notFixable',
        barLabel: 'value' as const,
      },
      {
        data: _scores.map(sc => sc.score.orange.noFix),
        label: 'High - Not Fixable',
        stack: 'notFixable',
        barLabel: 'value' as const,
      },
    ],
    [_scores],
  );

  return (
    <StackedBarChart
      chartData={chartData}
      series={series}
      routeSuffix="vulnerabilities"
      colors={[red[300], orange[300], red[200], orange[200]]}
      heightPerTeam={60}
    />
  );
};
